import { atomWithStorage } from 'jotai/utils'

const masterDataAtom = atomWithStorage('masterData', new Map())

export { masterDataAtom }
